import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/lock1.png'
import _imports_1 from '@/assets/lock2.png'
import _imports_2 from '@/assets/lock3.png'


const _withScopeId = n => (_pushScopeId("data-v-00feace0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row col-12 m-auto",
  style: {"margin-top":"90px !important"}
}
const _hoisted_2 = { class: "row col-12 m-auto" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "ts lock",
          to: "nolimit"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "ts lock",
          to: "fifteendays"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "ts lock",
          to: "thirtydays"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
}